module.exports = __webpack_public_path__ + "img/home_img_wxdt.678f249d.png";